import axiosIntents from '@/utils/axios-intents'

const GLEAP_SDK_KEY = process.env.VUE_APP_GLEAP_SDK_KEY

export default {
    actions: {
        InitGleapChat({ dispatch, getters }, should_chat_show = false) {
            if (!GLEAP_SDK_KEY) return

            const gleap_script_id = 'gleap-snippet'
            if (document.getElementById(gleap_script_id)) { return }

            // Gleap official init pattern — Proxy queues calls made before SDK loads
            if (!(window.Gleap = window.Gleap || []).invoked) {
                window.GleapActions = []

                const proxy = new Proxy({ invoked: true }, {
                    get: function(target, prop) {
                        return prop === 'invoked'
                            ? target.invoked
                            : function() {
                                const args = Array.prototype.slice.call(arguments)
                                window.GleapActions.push({ e: prop, a: args })
                            }
                    },
                    set: function(target, prop, value) {
                        target[prop] = value
                        return true
                    }
                })

                window.Gleap = proxy
            }

            const script = document.createElement('script')
            script.id = gleap_script_id
            script.type = 'text/javascript'
            script.async = true
            script.src = 'https://sdk.gleap.io/latest/index.js'

            // Wire load/error handlers BEFORE appending so cached scripts don't miss the event
            script.onload = () => {
                if (getters.is_account) {
                    dispatch('LogInGleapChat', should_chat_show).catch(error => {
                        console.error('Gleap login failed after SDK load:', error)
                    })
                }
            }

            script.onerror = (error) => {
                console.error('Failed to load Gleap SDK script:', error)
                const el = document.getElementById(gleap_script_id)
                if (el) el.remove()
            }

            // Initialize immediately — Proxy queues this if SDK hasn't loaded yet.
            // Call before appendChild so the queued init is in place even for
            // cached scripts whose onload may fire synchronously.
            window.Gleap.initialize(GLEAP_SDK_KEY)

            document.getElementsByTagName('head')[0].appendChild(script)
        },

        LogInGleapChat({ dispatch, getters }, should_chat_show = false) {
            if (!getters.is_account) return Promise.resolve()

            return axiosIntents.post('/support/login/:uuid?platform=web&provider=Gleap').then(({result}) => {
                if (!result) return Promise.reject(new Error('Not Gleap Provider'))

                if (result.Provider === 'Gleap') {
                    const name = [getters.account_first_name, getters.account_last_name].filter(Boolean).join(' ')
                    dispatch('LogInGleapUser', {
                        should_chat_show,
                        user_id: getters.current_account_uid,
                        email: getters.account_email,
                        name,
                        user_hash: result.Token,
                    })
                } else {
                    dispatch('LogOutGleapUser')
                }
            }).catch(error => {
                console.error('LogInGleapChat failed:', error)
                dispatch('LogOutGleapUser')
            })
        },

        LogInGleapUser(_, { should_chat_show = false, user_id, email, name, user_hash } = {}) {
            if (!window.Gleap) return

            window.Gleap.identify(
                user_id,
                {
                    ...(email && { email }),
                    ...(name && { name }),
                },
                user_hash,
            )

            if (should_chat_show) {
                window.Gleap.open()
            }
        },

        LogOutGleapUser() {
            if (!window.Gleap) return

            window.Gleap.clearIdentity()
        },
    },
}
